/* eslint-disable react/prop-types */
import React from 'react'
import { Card, Image, Flag, Popup, Label, Button } from 'semantic-ui-react'
import DefaultCard from './DefaultCard'
import ManageExpertCard from './ManageExpertCard'
import SocialIcon from '../../Resources/SocialIcon'
import countries from '../../../constants/countries.json'

const ExpertCard = ({
    expert,
    setUserId,
    selectedExperts,
    onSelect,
    setShowSidebar,
    type,
    job,
}) => {
    const checkInfoEmpty = (info) =>
        !info || info === '(none)' || info === '(unknown)'

    const renderSelectButton = () => {
        if (expert.expert.status !== 'Active' || expert.expert.isBlocked) {
            return (
                <Popup
                    position="top right"
                    trigger={
                        <Button
                            color="blue"
                            basic
                            floated="right"
                            size="mini"
                            style={{ opacity: 0.45, cursor: 'default' }}
                        >
                            Select
                        </Button>
                    }
                    content="You cannot invite an expert whose status is 'Do Not Contact' (those who have opted out of receiving email communications from Dexter) or 'Blocked' (those who have been restricted from all Dexter engagements due to violations of user terms and agreements)."
                />
            )
        }
        return (
            <Button
                color="blue"
                floated="right"
                size="mini"
                className={
                    selectedExperts
                        .map((expert) => expert.id)
                        .includes(expert.id)
                        ? null
                        : 'basic'
                }
                onClick={() => onSelect(expert)}
            >
                {selectedExperts
                    .map((expert) => expert.id)
                    .includes(expert.id)
                    ? 'Selected'
                    : 'Select'}
            </Button>
        )
    }

    return (
        <Card>
            <Card.Content>
                <Image
                    floated="left"
                    size="mini"
                    className="expert_profile"
                    src={
                        expert.expert.profile_picture ||
                        '/logos/fake_avatar.png'
                    }
                />
                {(type === 'SELECT_EXPERT' || type === 'MANAGE_EXPERT') &&
                    renderSelectButton()}
                <SocialIcon expert={expert} />
                <Card.Header>
                    <a
                        href="# "
                        className="expert_name_link"
                        onClick={(e) => {
                            e.preventDefault()
                            setShowSidebar(true)
                            setUserId(expert.id)
                        }}
                    >
                        {expert.fullName || expert.email}
                        {checkInfoEmpty(expert.expert.country) ? (
                            ''
                        ) : (
                            <Popup
                                content={expert.expert.country}
                                trigger={
                                    <Flag
                                        style={{ marginLeft: '5px' }}
                                        name={countries[expert.expert.country]}
                                    />
                                }
                            />
                        )}
                    </a>
                    {expert.expert.isBlocked && (
                        <Popup
                            trigger={
                                <Label
                                    color="black"
                                    horizontal
                                    style={{ marginLeft: '5px' }}
                                >
                                    Blocked
                                </Label>
                            }
                            content="This expert has been restricted from all Dexter engagements due to violations of user terms and agreements"
                        />
                    )}
                    {expert.expert.status === 'Do Not Contact' && (
                        <Popup
                            trigger={
                                <Label horizontal style={{ marginLeft: '5px' }}>
                                    Do Not Contact
                                </Label>
                            }
                            content="This expert has opted out of receiving email communications from Dexter"
                        />
                    )}
                </Card.Header>
                <Card.Meta>
                    {checkInfoEmpty(expert.expert.title)
                        ? ''
                        : expert.expert.title}{' '}
                    {checkInfoEmpty(expert.expert.title) ||
                    checkInfoEmpty(expert.expert.organization.name)
                        ? ''
                        : ','}{' '}
                    {checkInfoEmpty(expert.expert.organization.name)
                        ? ''
                        : expert.expert.organization.name}
                </Card.Meta>
                <Card.Description className="card-description">
                    {type === 'MANAGE_EXPERT' ? (
                        <ManageExpertCard expert={expert} job={job} />
                    ) : (
                        <DefaultCard expert={expert} />
                    )}
                </Card.Description>
            </Card.Content>
        </Card>
    )
}

export default ExpertCard
